import React, { Fragment, type FunctionComponent } from 'react'
import { MerchandisingFormField } from 'domains/merchandising/components/form-field/MerchandisingFormField'
import { MerchandisingFormRow } from 'domains/merchandising/components/form-row/MerchandisingFormRow'
import { MerchandisingFormInput } from 'domains/merchandising/components/form-input/MerchandisingFormInput'
import { MerchandisingFormColorInput } from 'domains/merchandising/components/form-input/MerchandisingFormColorInput'
import { type ControllerProps } from 'utils/react-hook-form/reactHookForm.types'

interface Props extends Omit<ControllerProps, 'name'> {}

export const BannerFormContentText: FunctionComponent<Props> = ({ form }) => {
  const { register, getValues, errors } = form

  return (
    <Fragment>
      <MerchandisingFormRow>
        <MerchandisingFormField>
          <MerchandisingFormInput
            identifier="headingText.text"
            ref={register({ required: true })}
            defaultValue={getValues('headingText.text')}
            labelId="bannersDomain.bannersForm.form.section.content.heading.label"
            maxLength={62}
            errors={errors}
            showLength
          />
        </MerchandisingFormField>

        <MerchandisingFormField>
          <MerchandisingFormColorInput
            identifier="headingText.color"
            defaultValue={getValues('headingText.color')}
            ref={register}
            labelId="bannersDomain.bannersForm.form.section.content.heading.color.label"
          />
        </MerchandisingFormField>
      </MerchandisingFormRow>

      <MerchandisingFormRow>
        <MerchandisingFormField>
          <MerchandisingFormInput
            identifier="subheadingText.text"
            defaultValue={getValues('subheadingText.text')}
            ref={register}
            labelId="bannersDomain.bannersForm.form.section.content.subheading.label"
            maxLength={58}
            showLength
          />
        </MerchandisingFormField>

        <MerchandisingFormField>
          <MerchandisingFormColorInput
            identifier="subheadingText.color"
            defaultValue={getValues('subheadingText.color')}
            ref={register}
            labelId="bannersDomain.bannersForm.form.section.content.subheading.color.label"
          />
        </MerchandisingFormField>
      </MerchandisingFormRow>

      <MerchandisingFormRow>
        <MerchandisingFormField>
          <MerchandisingFormInput
            identifier="button.label"
            defaultValue={getValues('button.label')}
            ref={register}
            labelId="bannersDomain.bannersForm.form.section.content.cta.cta.label"
            maxLength={20}
            showLength
          />
        </MerchandisingFormField>

        <MerchandisingFormField>
          <MerchandisingFormColorInput
            identifier="button.color"
            defaultValue={getValues('button.color')}
            ref={register}
            labelId={'merchandising.hero-banners.section.content.cta.color.label'}
          />
        </MerchandisingFormField>

        <MerchandisingFormField>
          <MerchandisingFormColorInput
            identifier="button.backgroundColor"
            defaultValue={getValues('button.backgroundColor')}
            ref={register}
            labelId={'bannersDomain.bannersForm.form.section.content.cta.backgroundColor.label'}
          />
        </MerchandisingFormField>
      </MerchandisingFormRow>

      <MerchandisingFormRow>
        <MerchandisingFormField>
          <MerchandisingFormColorInput
            identifier="backgroundColor"
            defaultValue={getValues('backgroundColor')}
            ref={register}
            labelId={'bannersDomain.bannersForm.form.section.content.backgroundColor.label'}
          />
        </MerchandisingFormField>
      </MerchandisingFormRow>
      {getValues('type') === 'HERO_BANNER' && (
        <MerchandisingFormRow>
          <MerchandisingFormField>
            <MerchandisingFormColorInput
              identifier="textareaColor"
              defaultValue={getValues('textareaColor')}
              ref={register}
              labelId={'bannersDomain.bannersForm.form.section.content.textareaColor.label'}
            />
          </MerchandisingFormField>
        </MerchandisingFormRow>
      )}
      {getValues('type') === 'SECONDARY_BANNER' && (
        <MerchandisingFormRow>
          <MerchandisingFormField>
            <MerchandisingFormInput
              identifier="secondaryText.text"
              defaultValue={getValues('secondaryText.text')}
              ref={register}
              labelId="bannersDomain.bannersForm.form.section.content.secondaryText.label"
              maxLength={25}
              showLength
            />
          </MerchandisingFormField>

          <MerchandisingFormField>
            <MerchandisingFormColorInput
              identifier="secondaryText.color"
              defaultValue={getValues('secondaryText.color')}
              ref={register}
              labelId="bannersDomain.bannersForm.form.section.content.secondaryText.color.label"
            />
          </MerchandisingFormField>
        </MerchandisingFormRow>
      )}
    </Fragment>
  )
}
